import { render, staticRenderFns } from "./ImportStaff.vue?vue&type=template&id=0627d0f6&"
import script from "./ImportStaff.vue?vue&type=script&lang=js&"
export * from "./ImportStaff.vue?vue&type=script&lang=js&"
import style0 from "./ImportStaff.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports